import { Descriptions, Empty, Modal, Spin } from "antd";
import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { leavePolicyComboGetById } from "../../redux/rtk/features/leavePolicy/leavePolicyComboApi";
import { buildComboViewDetails } from "./leavePolicyComboMapper";

export default function LeavePolicyComboViewModal({
	open,
	leavePolicyId,
	policyTitle,
	onClose,
}) {
	const dispatch = useDispatch();
	const masterData = useSelector((state) => state.masters?.masters) || {};
	const { loading, rawComboRecord } = useSelector((state) => state.compOffPolicy);

	useEffect(() => {
		if (open && leavePolicyId) {
			dispatch(leavePolicyComboGetById(leavePolicyId));
		}
	}, [open, leavePolicyId, dispatch]);

	const details = useMemo(
		() => buildComboViewDetails(rawComboRecord, masterData),
		[rawComboRecord, masterData]
	);

	return (
		<Modal
			title={`Combo-Off Policy${policyTitle ? ` — ${policyTitle}` : ""}`}
			open={open}
			onCancel={onClose}
			footer={null}
			width={620}
			centered={false}
			style={{ top: 28, paddingBottom: 16 }}
			destroyOnClose
			className="leave-policy-combo-view-modal"
			styles={{ body: { padding: "12px 16px", overflow: "hidden" } }}
		>
			<Spin spinning={loading}>
				<div className="leave-policy-combo-view-scroll">
					{!loading && !rawComboRecord ? (
						<Empty description="No combo-off configuration found for this policy." />
					) : (
						<Descriptions bordered column={1} size="small">
							{details.map(({ label, value }) => (
								<Descriptions.Item key={label} label={label}>
									{value}
								</Descriptions.Item>
							))}
						</Descriptions>
					)}
				</div>
			</Spin>
		</Modal>
	);
}
